import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility'; // Import the visibility icon
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { saveData, getData, openDB } from '../../../utils/db';
import { fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
// import '../../App.css';

function CompanyIndex() {
  const { isAuthenticated, companyId, permissions, isSuperAdmin, superCompanyId, logout, token } = useAuth();
  const [data, setData] = useState([]);
  const [deleteItemId, setDeleteItemId] = useState(null); // Track the item ID to delete
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  let companyid = companyId;
  if (isSuperAdmin == true && companyId == superCompanyId) {
    companyid = 0;
  }


  useEffect(() => {
    // Check if the token is expired
    if (isAuthenticated && tokenIsExpired(token)) {
      // Token is expired, log out the user
      logout();
      return;
    }

  }, [isAuthenticated, companyId, token, logout]);

  useEffect(() => {
    fetchData('CompanyApi', `/${companyid}`, token)
      .then((response) => {
        if (response.responseCode == '1111') {
          console.log(response);
          setData(response.response_data);
        }
      })
      .catch((error) => {
        console.error('Error fetching Company Details:', error);
      });
  }, []);


  return (
    <div className="w-full max-w-sm container mt-2 mx-auto">
      <div className='w-full mb-2 flex'>
        <h6 className='block uppercase tracking-wide text-black  productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Company</h6>
        {/* {isSuperAdmin && companyId == superCompanyId && (
          <Button
              variant="contained"
              color="primary"
              component={Link}
              to="/companyCreate"
              className="linkcolor"
              style={{ marginLeft: '8px' }}
            >
              CREATE NEW
            </Button>
        )} */}
      </div>

      <div className='w-full mb-5 flex' style={{ maxHeight: '600px', overflowY: 'auto' }}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
              <TableRow>
                <TableCell
                  style={{
                    background: 'linear-gradient(to right, #406b91ff, #27445D)', borderRadius: '5px', color: 'white', width: '40%',
                    fontWeight: '600', fontSize: '12px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                  }}>
                  Name
                </TableCell>
                <TableCell
                  style={{
                    background: 'linear-gradient(to right, #406b91ff, #27445D)', borderRadius: '5px', color: 'white', width: '10%',
                    fontWeight: '600', fontSize: '12px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                  }}>
                  Company Code
                </TableCell>
                <TableCell
                  style={{
                    background: 'linear-gradient(to right, #406b91ff, #27445D)', borderRadius: '5px', color: 'white', width: '20%',
                    fontWeight: '600', fontSize: '12px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                  }}>
                  Contact Number
                </TableCell>
                <TableCell
                  style={{
                    background: 'linear-gradient(to right, #406b91ff, #27445D)', borderRadius: '5px', color: 'white', width: '10%',
                    fontWeight: '600', fontSize: '12px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                  }}>
                  Email
                </TableCell>
                <TableCell
                  style={{
                    background: 'linear-gradient(to right, #406b91ff, #27445D)', borderRadius: '5px', color: 'white', width: '10%',
                    fontWeight: '600', fontSize: '12px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                  }}>
                  GST Number
                </TableCell>
                <TableCell
                  style={{
                    background: 'linear-gradient(to right, #406b91ff, #27445D)', borderRadius: '5px', color: 'white', width: '10%',
                    fontWeight: '600', fontSize: '12px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                  }}>
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map(item => (
                <TableRow key={item.Id}>
                  <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '2px', fontSize: '13px', width: '40%' }}>{item.Name}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '2px', fontSize: '13px', width: '10%' }}>{item.CompanyCode}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '2px', fontSize: '13px', width: '20%' }}>{item.ContactNumber1},{item.ContactNumber2}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '2px', fontSize: '13px', width: '10%' }}>{item.Email}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '2px', fontSize: '13px', width: '10%' }}>{item.GSTNumber}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '2px', fontSize: '13px', width: '10%' }}>
                    <Link to={`/companyEdit/${item.ID}`}>
                      <IconButton>
                        <EditIcon style={{ fontSize: '19px' }} />
                      </IconButton>
                    </Link>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>

  );
}

export default CompanyIndex;

